import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlusCircle } = FiIcons;

function GoalForm({ onAddGoal }) {
  const [goalText, setGoalText] = useState('');
  const [goalType, setGoalType] = useState('daily');

  const handleSubmit = () => {
    onAddGoal(goalText, goalType);
    setGoalText('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="p-8 bg-white rounded-3xl shadow-xl mb-8 border border-gray-100">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Aggiungi un Nuovo Obiettivo</h2>
      <div className="flex flex-col gap-6">
        <input 
          type="text" 
          value={goalText}
          onChange={(e) => setGoalText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Inserisci il tuo obiettivo..." 
          className="flex-1 p-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-lg"
        />
        <div className="flex flex-col sm:flex-row gap-4">
          <select 
            value={goalType}
            onChange={(e) => setGoalType(e.target.value)}
            className="flex-1 p-4 border border-gray-300 rounded-2xl bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          >
            <option value="daily">Giornaliero</option>
            <option value="weekly">Settimanale</option>
            <option value="monthly">Mensile</option>
            <option value="annual">Annuale</option>
          </select>
          <button 
            onClick={handleSubmit}
            className="flex-1 p-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3"
          >
            <SafeIcon icon={FiPlusCircle} />
            Aggiungi
          </button>
        </div>
      </div>
    </div>
  );
}

export default GoalForm;